import React from 'react';
import { Route } from "react-router-dom";
import CreditNotesNew from './credit_notes.new';
import CreditNotesView from './credit_notes.view';


const CreditNotesRouter = ({ match }) => (
  <div>
    <Route path={`${match.path}/:id`} component={CreditNotesView} />
    <Route
      exact
      path={match.path}
      component={CreditNotesNew}
    />
  </div>
);

export default CreditNotesRouter;
